import useSWR from "swr";
import { api } from "../services";

const BASE_URL = "/system-admin/interview";

export const useInterview = (params) => {
  const { startDate = "", endDate = "" } = params || {};

  const query = new URLSearchParams();

  query.append("startDate", startDate);
  query.append("endDate", endDate);

  const shouldFetch = startDate && endDate;
  const conditionalURL = shouldFetch ? `${BASE_URL}?${query.toString()}` : null;

  const { data, isLoading, mutate } = useSWR(conditionalURL, api.get);

  const create = async (data) => {
    const interview = await api.post(BASE_URL, data);
    return interview;
  };

  const update = async (id, data) => {
    const interview = await api.patch(`${BASE_URL}/${id}/edit`, data);
    return interview;
  };

  const find = async (query) => {
    const interview = await api.get(`${BASE_URL}/find?search=${query}`);
    return interview;
  };

  const getById = async (id) => {
    const response = await api.get(`${BASE_URL}/${id}`);
    return response;
  };

  return {
    isLoading: isLoading,
    data: data,
    mutate,
    create,
    update,
    find,
    getById,
  };
};

export const useInterviewById = (id) => {
  const { data, isLoading, mutate } = useSWR(id ? `${BASE_URL}/${id}` : null, api.get);

  const remove = async (id) => {
    const interview = await api.delete(`${BASE_URL}/${id}`);
    return interview;
  };

  return {
    isLoading: id ? isLoading : false,
    data,
    mutate,
    remove,
  };
};
